/* eslint-disable no-unused-vars */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';

const AccessibilityComplianceComponent = () => {
  return (
    <div className="v1811_831">
      <div className="v1811_947" />
      <div className="v1811_989" />
      <div className="v1811_990" />
      <span className="v1811_991">Accessibility Compliance</span>
      <div className="row mt-2" />
      <div className="row mt-2" />
      <div className="row mt-5">
        Thank you for visiting the Conduent MMIS Suite, a product of the
        Conduent. The product is dedicated to providing users with various types
        of information from the Department of Health and Human Services and
        other medical agencies. It is our intent that all users receive easy and
        efficient access to our web site. This site complies with Section 508
        Guidelines outlined by the Federal government. Section 508 compliance is
        completely satisfied by WCAG (1.0) Priorities 1 and 2. This site has a
        conformance level of "AA" meaning that all Priority 1 and 2 checkpoints
        are satisfied.
      </div>
      <div className="v374_928" />
      <div className="row ml-5 mt-5 mb-2">
        <div className="v1811_996">
          <SVGComponent
            iconName="polygon5"
            style={{ float: 'left', paddingRight: '8px' }}
          />{' '}
          If you are unable to view PDFs, please download
          <Link
            to="https://www.adobe.com/"
            role="button"
            style={{ color: '#004A99' }}
            target="_blank"
            className="a site-map ml-2"
            title="Adobe"
          >
            Adobe
          </Link>{' '}
          Reader. <br />
          <SVGComponent
            iconName="polygon5"
            style={{ float: 'left', paddingRight: '8px' }}
          />{' '}
          If you are unable to view Videos, please download
          <Link
            to="https://helpx.adobe.com/shockwave.html"
            style={{ color: '#004A99' }}
            role="button"
            target="_blank"
            className="a site-map ml-2"
            title="Adobe"
          >
            Adobe Shockwave Player.
          </Link>{' '}
        </div>
      </div>
      <span className="v1811_997">Accessibility Compliance</span>
    </div>
  );
};
export default AccessibilityComplianceComponent;
